import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { SSEHandler } from '@core/services/sse-handler.service';
import { JobsList } from '@shared/types/jobs-list.type';
import { HomesService } from '@shared/services/homes.service';

@Component({
  selector: 'im-test',
  templateUrl: './test.component.html',
  styleUrl: './test.component.scss',
})
export class TestComponent implements OnInit {
  http = inject(HttpClient);
  homesService = inject(HomesService);
  sseHandler = inject(SSEHandler);

  ngOnInit(): void {
    this.sseHandler.init();

    this.sseHandler.onMessage.subscribe({
      next: (message: JobsList) => {
        console.log(message);
      },
    });
  }
}
